import { Certificate } from "pmt-types/src/models/Certificate.ts";
import { PagedApiData } from "pmt-types/src/utils/PagedApiData.ts";
import { useQuery } from "react-query";
import { Maybe } from "../../utils/types/maybe.ts";
import { useAuthentication } from "../useAuthentication.ts";
import { QueryKeys } from "./queryKeys.ts";

export const useQueryGetCertificatesForEnrolleeId = (
  sourceId: Maybe<string>,
  projectId: Maybe<string>,
  enrolleeId: Maybe<string>,
) => {
  const { accessToken } = useAuthentication();

  return useQuery(
    [QueryKeys.GetEnrolleeCertificates, enrolleeId],
    async () => {
      const response = await fetch(
        `${
          import.meta.env.VITE_API_HOST
        }/sources/${sourceId}/projects/${projectId}/enrollees/${enrolleeId}/certificates`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            authorization: accessToken ?? "",
          },
        },
      );

      if (!response.ok) {
        throw new Error("Failed to query enrollee");
      }

      const apiData = (await response.json()) as PagedApiData<Certificate>;

      return apiData?.data ?? [];
    },
    {
      enabled:
        sourceId != null &&
        projectId != null &&
        enrolleeId != null &&
        enrolleeId != "new",
      onError: (error) => {
        console.error(
          "Failed to get certificates for enrollee",
          error,
          enrolleeId,
        );
      },
    },
  );
};
